import React from 'react';

import { useHistory } from 'react-router-dom';

import { IconButton } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import {
  Arrow,
  StyledAppsIcon,
  StyledBox,
  StyledIcon,
  StyledMenuItem,
  StyledPopper,
  Wrapper,
} from './AppsListV2.styles.js';

import { ReactComponent as Apps } from '../../../assets/images/Apps.svg';
import { ReactComponent as MarketCanvas } from '../../../assets/images/MarketCanvas.svg';
import { ReactComponent as OccupancyPlanner } from '../../../assets/images/OccupancyPlanner.svg';
import { ReactComponent as PortfolioOptimizer } from '../../../assets/images/PortfolioOptimizer.svg';
import { getEnvSuffix } from '../../../helpers/getEnv.js';
import { getLocationRoute } from '../../../helpers/routes/getLocationRoute';

const platformList = {
  'Market Canvas': `https://marketcanvas${getEnvSuffix()}.cbre.com`,
  'Occupancy Planner': `https://tgm${getEnvSuffix()}.green.cbre.com/occupancy-planner`,
  'Portfolio Analytics & Opportunities': `https://tgm${getEnvSuffix()}.green.cbre.com/opportunity-spotting`,
};

const AppsListV2 = ({ openAppsList, anchorAppsList, arrowRef, closeMenu }) => {
  const history = useHistory();

  const redictionHandler = (platform) => {
    const url = platformList[platform];

    url && window.open(url, '_blank');
    closeMenu();
  };

  return (
    <Wrapper>
      <IconButton onClick={openAppsList}>
        <StyledAppsIcon component={Apps} viewBox={'0 0 32 32'} />
      </IconButton>
      <StyledPopper
        anchorEl={anchorAppsList}
        open={Boolean(anchorAppsList)}
        placement="bottom-end"
        modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
      >
        <ClickAwayListener onClickAway={closeMenu}>
          <StyledBox>
            <Arrow ref={arrowRef} />
            <StyledMenuItem
              onClick={() => {
                history.push(getLocationRoute());
                closeMenu();
              }}
            >
              <StyledIcon viewBox={'0 0 40 40'}>
                <rect width="100%" height="100%" fill="gray" />
              </StyledIcon>
              MKII & FAST
            </StyledMenuItem>
            <StyledMenuItem onClick={(e) => redictionHandler(e.target.innerText)}>
              <StyledIcon component={MarketCanvas} viewBox={'0 0 40 40'} />
              Market Canvas
            </StyledMenuItem>
            <StyledMenuItem onClick={(e) => redictionHandler(e.target.innerText)}>
              <StyledIcon component={OccupancyPlanner} viewBox={'0 0 40 40'} />
              Occupancy Planner
            </StyledMenuItem>
            <StyledMenuItem onClick={(e) => redictionHandler(e.target.innerText)}>
              <StyledIcon component={PortfolioOptimizer} viewBox={'0 0 40 40'} />
              Portfolio Analytics & Opportunities
            </StyledMenuItem>
          </StyledBox>
        </ClickAwayListener>
      </StyledPopper>
    </Wrapper>
  );
};

export default AppsListV2;
